/* Vapor95 Runway section. Source: Documents\Vapor95-Runway\theme\assets\v95-runway.js
   Row of models; the active one stands front and centre, the rest step back. Move with arrows, keys,
   drag/swipe, a sideways trackpad scroll or a click on a model. The panel shows the active look's products. */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function layout(models, active, wide) {
    const gap = wide ? 0.2 : 0.42; // share of stage width between neighbours
    const n = models.length;
    models.forEach((m, i) => {
      // the row loops: each model sits at its shortest distance from the active one, left or right
      let o = i - active;
      if (n > 2) { if (o > n / 2) o -= n; if (o < -n / 2) o += n; if (n % 2 === 0 && o === n / 2) o = -o; }
      const d = Math.abs(o);
      const scale = d === 0 ? 1 : Math.max(0.52, 0.78 - (d - 1) * 0.1);
      const x = o * gap * 100 * (d === 0 ? 1 : 1 - (d - 1) * 0.12);
      const y = d === 0 ? 0 : -6 - (d - 1) * 3; // further back = a little higher on the floor
      m.style.transform = `translateX(-50%) translate(${x}cqw, ${y}%) scale(${scale})`;
      m.style.opacity = d === 0 ? "1" : d === 1 ? ".72" : d === 2 ? ".38" : "0";
      m.style.filter = d === 0 ? "none" : `blur(${Math.min(d, 3) * 1.1}px) saturate(${1 - d * 0.18})`;
      m.style.zIndex = String(40 - d);
      m.style.pointerEvents = d > 2 ? "none" : "";
      m.classList.toggle("is-active", d === 0);
      m.setAttribute("aria-current", d === 0 ? "true" : "false");
      m.tabIndex = d === 0 ? -1 : 0;
    });
  }

  function money(cents, fallbackEl) {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) { return fallbackEl ? fallbackEl.textContent : (cents / 100).toFixed(2); }
  }

  async function addToCart(items) {
    const r = await fetch(`${ROOT}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items, sections: "cart-items,cart-footer,cart-item-count", sections_url: location.pathname }),
    });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || "Couldn't add that to your bag.");
    // Same event the theme's own quick buy fires: updates the count + opens the cart (MegaCart takes it over).
    document.body.dispatchEvent(new CustomEvent("shapes:cart:afteradditem", { bubbles: true, detail: { response: data } }));
    return data;
  }

  function init(root) {
    if (root.dataset.v95rwReady) return;
    root.dataset.v95rwReady = "1";
    const stage = root.querySelector("[data-v95rw-stage]");
    const models = [...root.querySelectorAll("[data-v95rw-model]")];
    const looks = [...root.querySelectorAll("[data-v95rw-look]")];
    const num = root.querySelector("[data-v95rw-num]");
    if (!models.length) return;
    stage.style.containerType = "inline-size";
    let active = 0;
    const wideMq = window.matchMedia("(min-width: 990px)");
    const bundle = +root.dataset.bundle || 0;

    const go = (i) => {
      active = (i + models.length) % models.length;
      layout(models, active, wideMq.matches);
      looks.forEach((l, k) => (l.hidden = k !== active));
      if (num) num.textContent = String(active + 1);
    };
    go(0);
    wideMq.addEventListener?.("change", () => go(active));

    root.querySelector("[data-v95rw-prev]").addEventListener("click", () => go(active - 1));
    root.querySelector("[data-v95rw-next]").addEventListener("click", () => go(active + 1));
    models.forEach((m, i) => m.addEventListener("click", (e) => { if (moved) { e.preventDefault(); return; } if (i !== active) go(i); }));
    stage.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") { e.preventDefault(); go(active + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); go(active - 1); }
    });

    // drag / swipe
    let x0 = null, y0 = null, moved = false, pid = null;
    stage.addEventListener("pointerdown", (e) => {
      if (e.button !== 0 || e.target.closest(".v95rw__nav")) return;
      x0 = e.clientX; y0 = e.clientY; moved = false; pid = e.pointerId;
    });
    stage.addEventListener("pointermove", (e) => {
      if (x0 === null || e.pointerId !== pid) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      if (!moved && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) { moved = true; stage.classList.add("is-dragging"); try { stage.setPointerCapture(pid); } catch (_) {} }
      if (moved && Math.abs(dx) > 60) { go(active + (dx < 0 ? 1 : -1)); x0 = e.clientX; y0 = e.clientY; }
    });
    const end = () => { x0 = null; stage.classList.remove("is-dragging"); setTimeout(() => (moved = false), 0); };
    stage.addEventListener("pointerup", end);
    stage.addEventListener("pointercancel", end);

    // sideways trackpad / shift+wheel scroll (vertical page scrolling is left alone)
    let wheelAcc = 0, wheelLock = 0;
    stage.addEventListener("wheel", (e) => {
      const dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.shiftKey ? e.deltaY : 0;
      if (!dx) return;
      e.preventDefault();
      const now = Date.now();
      if (now < wheelLock) return;
      wheelAcc += dx;
      if (Math.abs(wheelAcc) > 40) { go(active + (wheelAcc > 0 ? 1 : -1)); wheelAcc = 0; wheelLock = now + 450; }
    }, { passive: false });

    // panel: prices follow the size picked; + adds one piece; the big button adds the whole look
    looks.forEach((look) => {
      const items = [...look.querySelectorAll("[data-v95rw-item]")];
      const totalEl = look.querySelector("[data-v95rw-total]");
      const msg = look.querySelector("[data-v95rw-msg]");
      const say = (t, err) => { msg.textContent = t; msg.classList.toggle("is-error", !!err); };
      const sync = () => {
        let cents = 0, bundled = 0;
        items.forEach((it) => {
          const sel = it.querySelector("select[data-v95rw-variant]");
          const opt = sel && sel.selectedOptions[0];
          const c = opt ? +opt.dataset.cents : +(it.dataset.cents || 0);
          if (opt) it.querySelector("[data-v95rw-price]").textContent = opt.dataset.price;
          cents += c;
          bundled += c - Math.round(c * bundle / 100); // Shopify rounds the discount per line

        });
        if (cents) {
          const was = look.querySelector("[data-v95rw-was]");
          if (was) was.textContent = money(cents, was);
          totalEl.textContent = money(was ? bundled : cents, totalEl);
        }
      };
      items.forEach((it) => {
        const sel = it.querySelector("select[data-v95rw-variant]");
        if (!sel) {
          // single-variant product: remember its price for the total
          const p = it.querySelector("[data-v95rw-price]").textContent.replace(/[^0-9.,]/g, "").replace(/,(?=\d{3})/g, "").replace(",", ".");
          it.dataset.cents = String(Math.round(parseFloat(p || "0") * 100));
        }
        sel && sel.addEventListener("change", sync);
        const btn = it.querySelector("[data-v95rw-add]");
        btn.addEventListener("click", async () => {
          const id = +it.querySelector("[data-v95rw-variant]").value;
          btn.classList.add("is-busy"); say("");
          try { await addToCart([{ id, quantity: 1 }]); const label = btn.textContent; btn.classList.add("is-done"); btn.textContent = "Added"; setTimeout(() => { btn.classList.remove("is-done"); btn.textContent = label; }, 1800); }
          catch (err) { say(err.message, true); }
          finally { btn.classList.remove("is-busy"); }
        });
      });
      sync();
      // fade the bottom of the list while there's more to scroll
      const list = look.querySelector(".v95rw__items");
      const wrap = list.parentElement, sb = wrap.querySelector(".v95rw__sb"), thumb = sb && sb.querySelector(".v95rw__sbthumb");
      const geo = () => { const sh = list.scrollHeight, ch = list.clientHeight, th = sb.clientHeight;
        const h = Math.max(28, Math.round(th * ch / Math.max(sh, 1))); return { sh, ch, th, h, max: Math.max(sh - ch, 1), room: Math.max(th - h, 1) }; };
      const edge = () => {
        const can = list.scrollHeight > list.clientHeight + 2;
        list.classList.toggle("is-scrollable", can); wrap.classList.toggle("is-scrollable", can);
        list.classList.toggle("is-end", list.scrollTop + list.clientHeight >= list.scrollHeight - 4);
        if (!sb || !can) return;
        const g = geo();
        thumb.style.setProperty("--sb-h", g.h + "px");
        thumb.style.setProperty("--sb-y", Math.round(list.scrollTop / g.max * g.room) + "px");
      };
      // drag the thumb, or tap the track to jump there
      if (sb) sb.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        const g = geo(), r = sb.getBoundingClientRect();
        if (e.target !== thumb) list.scrollTop = (e.clientY - r.top - g.h / 2) / g.room * g.max;
        const y0 = e.clientY, t0 = list.scrollTop;
        sb.classList.add("is-drag"); sb.setPointerCapture(e.pointerId);
        const move = (ev) => { list.scrollTop = t0 + (ev.clientY - y0) * g.max / g.room; };
        const up = () => { sb.classList.remove("is-drag"); sb.removeEventListener("pointermove", move); sb.removeEventListener("pointerup", up); sb.removeEventListener("pointercancel", up); };
        sb.addEventListener("pointermove", move); sb.addEventListener("pointerup", up); sb.addEventListener("pointercancel", up);
      });
      list.addEventListener("scroll", edge, { passive: true });
      new ResizeObserver(edge).observe(list);
      const all = look.querySelector("[data-v95rw-all]");
      all.addEventListener("click", async () => {
        const list = items.filter((it) => !it.querySelector("[data-v95rw-add]").disabled).map((it) => ({ id: +it.querySelector("[data-v95rw-variant]").value, quantity: 1 }));
        if (!list.length) return say("This look is sold out right now.", true);
        all.classList.add("is-busy"); say("");
        try { await addToCart(list); say(bundle ? `Added the full look. ${bundle}% off each piece comes off in your bag.` : `Added ${list.length} pieces to your bag.`); }
        catch (err) { say(err.message, true); }
        finally { all.classList.remove("is-busy"); }
      });
    });
  }

  const boot = () => document.querySelectorAll("[data-v95rw]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
